module.exports = __webpack_public_path__ + "static/img/noImage.070fb8a.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/noImage.png
// module id = u6Sp
// module chunks = 4